module.exports = {
    setDashboardMeta (title, description) {
        return (args, state) => {
            state.set(['title'], title);
            state.set(['description'], description);
        };
    }
};



// WEBPACK FOOTER //
// ./actions/seo.js